import React from "react";
import "./styles.css";

type VersionSelectorProps = {
  versions: string[];
  onChange: (value: string) => void;
};

const CustomSelect = ({ versions, onChange }: VersionSelectorProps) => {

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value);
  };

  const menuItems = versions.map((version: string, index: number) => (
    <option key={index} value={version}>
      {version}
    </option>
  ));

  return (
    <div>
      Version:{" "}
      <select className="custom-select-options" onChange={handleChange}>
        {menuItems}
      </select>
    </div>
  );
};

export default CustomSelect;
